// data/gameData.ts

export interface Game {
    id: number;
    title: string;
    author: string;
    url: string;
    jamName: string;
    jamUrl: string;
    jamType: 'marathon' | 'themed'; // Simplified to just marathon vs themed
    jamTheme?: string; // Added theme field
    placement?: number; // Winner placement (1st, 2nd, 3rd)
    thumb: string;
    image?: string;
}

export const gameData: Game[] = [
    {
        id: 1,
        title: "There's Something Wrong With This World",
        author: "@blackvoidtytan",
        url: "https://blackvoidmedia.itch.io/theres-something-wrong-with-this-world",
        jamName: "Solo Dev Jam #1",
        jamUrl: "https://itch.io/jam/solodevelopment-game-jam",
        jamType: "themed",
        jamTheme: "Minimalism",
        thumb: "T",
        image: "/images/games/something-wrong-world.jpg"
    },
    {
        id: 2,
        title: "DF FBLA",
        author: "@lonelylily",
        url: "https://razziefox.itch.io/df-fbla",
        jamName: "First Marathon Jam",
        jamUrl: "https://itch.io/jam/marathon-jam-by-solodevelopment",
        jamType: "marathon",
        jamTheme: "Work on your own project",
        thumb: "D",
        image: "/images/games/df-fbla.jpg"
    },
    {
        id: 3,
        title: "I Came Home Tonight",
        author: "@blackvoidtytan and @radagast08",
        url: "https://blackvoidmedia.itch.io/i-came-home-tonight",
        jamName: "Solo Dev Jam #2",
        jamUrl: "https://itch.io/jam/halloween-jam-2021",
        jamType: "themed",
        jamTheme: "Ghosts doing Normal People Things",
        thumb: "I",
        image: "/images/games/i-came-home-tonight.jpg"
    },
    {
        id: 4,
        title: "Track Master",
        author: "@ensom_",
        url: "https://uppastgamer.itch.io/track-master",
        jamName: "Solo Dev Jam #3",
        jamUrl: "https://itch.io/jam/winter-jam-by-solodevelopment",
        jamType: "themed",
        jamTheme: "End is Near",
        thumb: "T",
        image: "/images/games/track-master.jpg"
    },
    {
        id: 5,
        title: "Scavengers from Planet X",
        author: "@fernandolv3",
        url: "https://fernandolv3.itch.io/scavengersfromplanetx",
        jamName: "Second Marathon Jam",
        jamUrl: "https://itch.io/jam/marathon-jam-2022-by-solodevelopment",
        jamType: "marathon",
        jamTheme: "Work on your own project",
        thumb: "S",
        image: "/images/games/scavengers-planet-x.jpg"
    },
    {
        id: 6,
        title: "Out Here Alone",
        author: "@blackvoidtytan",
        url: "https://blackvoidmedia.itch.io/out-here-alone",
        jamName: "Third Marathon Jam",
        jamUrl: "https://itch.io/jam/marathon-jam-3-by-solodevelopment",
        jamType: "marathon",
        jamTheme: "Work on your own project",
        thumb: "O",
        image: "/images/games/out-here-alone.jpg"
    },
    {
        id: 7,
        title: "Mutual Assured Destruction Simulator",
        author: "@blackvoidtytan",
        url: "https://blackvoidmedia.itch.io/mutual-assured-destruction-simulator",
        jamName: "Solo Dev Jam #4",
        jamUrl: "https://itch.io/jam/solo-dev-game-jam-4",
        jamType: "themed",
        jamTheme: "Two Button Controls",
        thumb: "M",
        image: "/images/games/mutual-destruction.jpg"
    },
    {
        id: 8,
        title: "Dodge the Question",
        author: "@gripgrap",
        url: "https://gripgrap.itch.io/dodge-the-question",
        jamName: "Solo Dev Jam #4",
        jamUrl: "https://itch.io/jam/solo-dev-game-jam-4",
        jamType: "themed",
        jamTheme: "Two Button Controls",
        thumb: "D",
        image: "/images/games/dodge-the-question.jpg"
    },
    {
        id: 9,
        title: "Six Rolls Six",
        author: "@yikag",
        url: "https://yikag.itch.io/six-rolls-six",
        jamName: "Solo Dev Jam #4",
        jamUrl: "https://itch.io/jam/solo-dev-game-jam-4",
        jamType: "themed",
        jamTheme: "Two Button Controls",
        thumb: "S",
        image: "/images/games/six-rolls-six.jpg"
    },
    {
        id: 10,
        title: "Guardian of the Grave",
        author: "@drahmen",
        url: "https://drahmen.itch.io/guardian-of-the-grave",
        jamName: "Solo Dev Jam #5",
        jamUrl: "https://itch.io/jam/solo-dev-game-jam-5-spooky-jam",
        jamType: "themed",
        jamTheme: "Fight The Dark",
        thumb: "G",
        image: "/images/games/guardian-of-the-grave.jpg"
    },
    {
        id: 11,
        title: "Hank The Imp",
        author: "@Emcee",
        url: "https://emceetheguy.itch.io/hanktheimp",
        jamName: "Solo Dev Jam #5",
        jamUrl: "https://itch.io/jam/solo-dev-game-jam-5-spooky-jam",
        jamType: "themed",
        jamTheme: "Fight The Dark",
        thumb: "H",
        image: "/images/games/hank-the-imp.jpg"
    },
    {
        id: 12,
        title: "Maybel in the Hazy Hotel",
        author: "@log64",
        url: "https://log64.itch.io/maybel-in-the-hazy-hotel",
        jamName: "Solo Dev Jam #5",
        jamUrl: "https://itch.io/jam/solo-dev-game-jam-5-spooky-jam",
        jamType: "themed",
        jamTheme: "Fight The Dark",
        thumb: "M",
        image: "/images/games/maybel-hazy-hotel.jpg"
    },
    {
        id: 13,
        title: "Operation MC: Codename Melting Point",
        author: "@drahmen",
        url: "https://drahmen.itch.io/operation-mc-codename-melting-point",
        jamName: "Solo Dev Jam #6",
        jamUrl: "https://itch.io/jam/solodevelopment-jam-6-winter-jam",
        jamType: "themed",
        jamTheme: "Under the Surface / Hot and Cold",
        thumb: "O",
        image: "/images/games/operation-mc.jpg"
    },
    {
        id: 14,
        title: "Hack the Loop",
        author: "@ProYd",
        url: "https://proyd.itch.io/hack-the-loop",
        jamName: "Solo Development Marathon Jam 4",
        jamUrl: "https://itch.io/jam/solodev-marathon-jam-4",
        jamType: "marathon",
        jamTheme: "Work on your own project",
        thumb: "H",
        image: "/images/games/hack-the-loop.jpg"
    },
    {
        id: 15,
        title: "YesterSol",
        author: "@NeatGames",
        url: "https://neatgames.itch.io/yestersol",
        jamName: "Solo Development Marathon Jam 4",
        jamUrl: "https://itch.io/jam/solodev-marathon-jam-4",
        jamType: "marathon",
        jamTheme: "Work on your own project",
        thumb: "Y",
        image: "/images/games/yestersol.jpg"
    },
    {
        id: 16,
        title: "Survive The Day: Dave's Coffee",
        author: "@Lou Bagel",
        url: "https://loubagel.itch.io/daves-coffee",
        jamName: "Solo Development Marathon Jam 4",
        jamUrl: "https://itch.io/jam/solodev-marathon-jam-4",
        jamType: "marathon",
        jamTheme: "Work on your own project",
        thumb: "S",
        image: "/images/games/daves-coffee.jpg"
    },
    {
        id: 17,
        title: "Star Modulus",
        author: "@Blurr507",
        url: "https://blurr507.itch.io/star-modulus",
        jamName: "Solo Dev Jam #7",
        jamUrl: "https://itch.io/jam/solodevelopment-jam-7",
        jamType: "themed",
        jamTheme: "Parts and Upgrades",
        placement: 1,
        thumb: "S",
        image: "/images/games/star-modulus.jpg"
    },
    {
        id: 18,
        title: "Cow Combo",
        author: "@LateAFCoffee",
        url: "https://lateafcoffee.itch.io/cow-combo",
        jamName: "Solo Dev Jam #7",
        jamUrl: "https://itch.io/jam/solodevelopment-jam-7",
        jamType: "themed",
        jamTheme: "Parts and Upgrades",
        placement: 2,
        thumb: "C",
        image: "/images/games/cow-combo.jpg"
    },
    {
        id: 19,
        title: "Modular Mayhem",
        author: "@Unremarkable1",
        url: "https://unremarkable1.itch.io/modular-mayhem",
        jamName: "Solo Dev Jam #7",
        jamUrl: "https://itch.io/jam/solodevelopment-jam-7",
        jamType: "themed",
        jamTheme: "Parts and Upgrades",
        placement: 3,
        thumb: "M",
        image: "/images/games/modular-mayhem.jpg"
    },
    {
        id: 20,
        title: "Entropy",
        author: "@supermuttgames",
        url: "https://itch.io/jam/solodevelopment-summer-jam/rate/3804442",
        jamName: "Solo Dev Jam #8",
        jamUrl: "https://itch.io/jam/solodevelopment-summer-jam",
        jamType: "themed",
        jamTheme: "Chaos",
        placement: 1,
        thumb: "E",
        image: "/images/games/entropy.gif"
    },
    {
        id: 21,
        title: "Routine Mayhem",
        author: "@xlanders",
        url: "https://itch.io/jam/solodevelopment-summer-jam/rate/3802980",
        jamName: "Solo Dev Jam #8",
        jamUrl: "https://itch.io/jam/solodevelopment-summer-jam",
        jamType: "themed",
        jamTheme: "Chaos",
        placement: 2,
        thumb: "R",
        image: "/images/games/routine-mayhem.png"
    },
    {
        id: 22,
        title: "Me when I fight the primordial hypergod of chaos:",
        author: "@deltav0_",
        url: "https://itch.io/jam/solodevelopment-summer-jam/rate/3801057",
        jamName: "Solo Dev Jam #8",
        jamUrl: "https://itch.io/jam/solodevelopment-summer-jam",
        jamType: "themed",
        jamTheme: "Chaos",
        placement: 3,
        thumb: "M",
        image: "/images/games/primordial-hypergod.png"
    },
    {
        id: 23,
        title: "Inkfoot",
        author: "cyrealboxx",
        url: "https://cyrealboxx.itch.io/inkfoot",
        jamName: "Solo Dev Jam #9",
        jamUrl: "https://itch.io/jam/solodevelopment-jam-9-halloween",
        jamType: "themed",
        jamTheme: "Black and White",
        placement: 1,
        thumb: "I",
        image: "/images/games/inkfoot.png"
    },
    {
        id: 24,
        title: "The Angels Arose (And Tore Us Apart)",
        author: "@blackvoidtytan",
        url: "https://blackvoidmedia.itch.io/the-angels-arose",
        jamName: "Solo Dev Jam #9",
        jamUrl: "https://itch.io/jam/solodevelopment-jam-9-halloween",
        jamType: "themed",
        jamTheme: "Black and White",
        placement: 1,
        thumb: "T",
        image: "/images/games/angels-arose.jpg"
    },
    {
        id: 25,
        title: "Achromatopsia",
        author: "@zelgadis6737",
        url: "https://yurga.itch.io/achromatopsia",
        jamName: "Solo Dev Jam #9",
        jamUrl: "https://itch.io/jam/solodevelopment-jam-9-halloween",
        jamType: "themed",
        jamTheme: "Black and White",
        placement: 3,
        thumb: "A",
        image: "/images/games/achromatopsia.png"
    },
    {
        id: 26,
        title: "Fabled Footy Demo",
        author: "@justacupgames",
        url: "https://jcupdev.itch.io/fabled-footy",
        jamName: "Marathon Jam #5 — Community Voted",
        jamUrl: "https://itch.io/jam/solodevelopment-marathon-jam-5",
        jamType: "marathon",
        jamTheme: "Work on your own project",
        placement: 1,
        thumb: "F",
        image: "/images/games/fabled-footy.jpg"
    },
    {
        id: 27,
        title: "Kill The Eye",
        author: "Ar",
        url: "https://ardue.itch.io/kill-the-eye",
        jamName: "Marathon Jam #5 — Community Voted",
        jamUrl: "https://itch.io/jam/solodevelopment-marathon-jam-5",
        jamType: "marathon",
        jamTheme: "Work on your own project",
        placement: 2,
        thumb: "K",
        image: "/images/games/kill-the-eye.png"
    },
    {
        id: 28,
        title: "11th Floor",
        author: "@angelhyype",
        url: "https://angelhyype.itch.io/11th-floor",
        jamName: "Marathon Jam #5 — Community Voted",
        jamUrl: "https://itch.io/jam/solodevelopment-marathon-jam-5",
        jamType: "marathon",
        jamTheme: "Work on your own project",
        placement: 3,
        thumb: "1",
        image: "/images/games/11th-floor.png"
    },
    {
        id: 29,
        title: "Kill The Eye",
        author: "Ar",
        url: "https://ardue.itch.io/kill-the-eye",
        jamName: "Marathon Jam #5 — Cash Prize (Judge Selected)",
        jamUrl: "https://itch.io/jam/solodevelopment-marathon-jam-5",
        jamType: "marathon",
        jamTheme: "Work on your own project",
        placement: 1,
        thumb: "K",
        image: "/images/games/kill-the-eye.png"
    },
    {
        id: 30,
        title: "Just Another Worldview",
        author: "@coderkillo",
        url: "https://coderkillo.itch.io/just-another-worldview",
        jamName: "Marathon Jam #5 — Cash Prize (Judge Selected)",
        jamUrl: "https://itch.io/jam/solodevelopment-marathon-jam-5",
        jamType: "marathon",
        jamTheme: "Work on your own project",
        placement: 2,
        thumb: "J",
        image: "/images/games/just-another-worldview.png"
    },
    {
        id: 31,
        title: "Segworm",
        author: "@dur__ka",
        url: "https://dur-ka.itch.io/segworm",
        jamName: "Marathon Jam #5 — Cash Prize (Judge Selected)",
        jamUrl: "https://itch.io/jam/solodevelopment-marathon-jam-5",
        jamType: "marathon",
        jamTheme: "Work on your own project",
        placement: 3,
        thumb: "S",
        image: "/images/games/segworm.gif"
    },
    {
        id: 32,
        title: "Plushplotion",
        author: "@beosil",
        url: "https://beosil.itch.io/plushplotion",
        jamName: "Solo Dev Jam #10",
        jamUrl: "https://itch.io/jam/solodevelopment-10-new-year-jam",
        jamType: "themed",
        jamTheme: "Countdown & You Are The Villain",
        placement: 1,
        thumb: "P",
        image: "/images/games/plushplotion.png"
    },
    {
        id: 33,
        title: "Thalassophobia",
        author: "@solidmint",
        url: "https://shinsekaiplusplus.itch.io/thalassophobia",
        jamName: "Solo Dev Jam #10",
        jamUrl: "https://itch.io/jam/solodevelopment-10-new-year-jam",
        jamType: "themed",
        jamTheme: "Countdown & You Are The Villain",
        placement: 2,
        thumb: "T",
        image: "/images/games/thalassophobia.png"
    },
    {
        id: 34,
        title: "Furry Menace",
        author: "@treno11",
        url: "https://treno11.itch.io/furry-menace",
        jamName: "Solo Dev Jam #10",
        jamUrl: "https://itch.io/jam/solodevelopment-10-new-year-jam",
        jamType: "themed",
        jamTheme: "Countdown & You Are The Villain",
        placement: 3,
        thumb: "F",
        image: "/images/games/furry-menace.jpg"
    },
    {
        id: 35,
        title: "Input Tax",
        author: "@chillfruit",
        url: "https://chillfruit.itch.io/input-tax",
        jamName: "Solo Dev Jam #11",
        jamUrl: "https://itch.io/jam/solo-dev-jam-11",
        jamType: "themed",
        jamTheme: "Everything Has a Cost",
        placement: 1,
        thumb: "I",
        image: "/images/games/input-tax.png"
    },
    {
        id: 36,
        title: "Statistically You",
        author: "@mizu",
        url: "https://chemizu.itch.io/statistically-you",
        jamName: "Solo Dev Jam #11",
        jamUrl: "https://itch.io/jam/solo-dev-jam-11",
        jamType: "themed",
        jamTheme: "Everything Has a Cost",
        placement: 2,
        thumb: "S",
        image: "/images/games/statistically-you.png"
    },
    {
        id: 37,
        title: "Monger Drop",
        author: "@drahmen",
        url: "https://drahmen.itch.io/monger-drop",
        jamName: "Solo Dev Jam #11",
        jamUrl: "https://itch.io/jam/solo-dev-jam-11",
        jamType: "themed",
        jamTheme: "Everything Has a Cost",
        placement: 3,
        thumb: "M",
        image: "/images/games/monger-drop.png"
    }
];

// Featured games for homepage (subset of gameData)
export const featuredGames = [
    gameData[0], // There's Something Wrong With This World
    gameData[9], // Guardian of the Grave  
    gameData[14], // YesterSol
    gameData[3] // Track Master
];